export default {
  prepareSequenceImages: Array(36)
    .fill('')
    .map((v, i) =>
      require(`../../../Box_sequences/stena/stena${i < 10 ? `0${i}` : i}.jpg`)
    ),
  designSliderImage: require('../../../product drawing/stena/bookshelf.png'),
  designImageList: [
    {
      number: 1,
      side: 'BOTTOM',
      image: require('../../../parts/bookshelf/1.png'),
    },
    {
      number: 2,
      side: 'BACK',
      image: require('../../../parts/bookshelf/2.png'),
    },
    {
      number: 3,
      side: 'RIGHT',
      image: require('../../../parts/bookshelf/3.png'),
    },
    {
      number: 4,
      side: 'LEFT',
      image: require('../../../parts/bookshelf/4.png'),
    },
  ],
  cutOutPartsImage: require('../../../parts/bookshelf/cutter.png'),
  assembleSequenceImages: Array(24)
    .fill('')
    .map((v, i) =>
      require(`../../../sequences/05_bookshelf_sequence/bookshelf${
        i < 10 ? `0${i}` : i
      }.jpg`)
    ),
  completeImage: require('../../../complete/32book.png'),
  completeImagePc: require('../../../complete/32book.png'),
};
